import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ChatWidget } from "./components/ChatWidget";
import { SEOMetaTags } from "./components/SEOMetaTags";
import { AnimatePresence } from "framer-motion";
import { PageTransition } from "./components/PageTransition";
import IntakeForm from "./pages/IntakeForm";
import ResultPage from "./pages/ResultPage";
import RetailMenuPage from "./pages/RetailMenuPage";
import ConciergePage from "./pages/ConciergePage";
import PaymentSuccess from "./pages/PaymentSuccess";
import TrackPage from "./pages/TrackPage";
import PortalAuth from "./pages/PortalAuth";
import PortalDashboard from "./pages/PortalDashboard";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import OrderPage from "./pages/OrderPage";
import "./App.css";

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransition><IntakeForm /></PageTransition>} />
        <Route path="/result/:submissionId" element={<PageTransition><ResultPage /></PageTransition>} />
        <Route path="/retail/:submissionId" element={<PageTransition><RetailMenuPage /></PageTransition>} />
        <Route path="/menu" element={<PageTransition><RetailMenuPage /></PageTransition>} />
        <Route path="/concierge/:submissionId" element={<PageTransition><ConciergePage /></PageTransition>} />
        <Route path="/payment-success" element={<PageTransition><PaymentSuccess /></PageTransition>} />
        <Route path="/track" element={<PageTransition><TrackPage /></PageTransition>} />
        <Route path="/portal/login" element={<PageTransition><PortalAuth /></PageTransition>} />
        <Route path="/portal" element={<PageTransition><PortalDashboard /></PageTransition>} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/terms" element={<PageTransition><TermsPage /></PageTransition>} />
        <Route path="/privacy" element={<PageTransition><PrivacyPage /></PageTransition>} />
        <Route path="/order" element={<PageTransition><OrderPage /></PageTransition>} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <Router>
      <Toaster position="top-right" theme="dark" />
      <ChatWidget />
      <SEOMetaTags />
      <AnimatedRoutes />
    </Router>
  );
}

export default App;
